export const EMPTY_STRING: Readonly<string> = "";

export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export enum InputTypes {
  password = "password",
  text = "text",
}

export enum ErrorTypes {
  info = "info",
  warning = "warning",
  success = "success",
}
